export default __webpack_public_path__ + "static/media/font.d206c4e4.woff2";